import { render, staticRenderFns } from "./templatePreview.vue?vue&type=template&id=80227db4&scoped=true&"
import script from "./templatePreview.vue?vue&type=script&lang=js&"
export * from "./templatePreview.vue?vue&type=script&lang=js&"
import style0 from "./templatePreview.vue?vue&type=style&index=0&id=80227db4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80227db4",
  null
  
)

export default component.exports